/* PlanJapon — section « bento » (sections/pj-bento.liquid), maquette validée le 2026-09-26.
   Tout ce qui boucle est en CSS et se suspend hors écran avec .pj-offscreen (pj-motion.js). Ce script :
   pose ce qui dépend de la taille (rails du schéma IP, vol, épingles et bulle d'arrivée sans chevauchement),
   remplit les pistes de logos pour qu'elles défilent sans trou, dessine le QR décoratif, fait monter le
   compteur de Go, et marque les tuiles visibles (.is-live) pour que leurs animations démarrent sous les yeux. */
(function () {
  var MOTION = document.documentElement.classList.contains('motion');

  /* ---------- QR décoratif (non scannable), le même motif à chaque visite ---------- */
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function drawQr(svg) {
    var N = 21, r = rng(+svg.getAttribute('data-seed') || 3), d = '';
    function finder(i, j) { var a = Math.max(Math.abs(i - 3), Math.abs(j - 3)); return a !== 2 && a <= 3; }
    for (var y = 0; y < N; y++) for (var x = 0; x < N; x++) {
      var on, inF = (x < 8 && y < 8) || (x > 12 && y < 8) || (x < 8 && y > 12);
      if (inF) { var ox = x > 12 ? 14 : 0, oy = y > 12 ? 14 : 0; on = (x - ox < 7 && y - oy < 7) ? finder(x - ox, y - oy) : false; }
      else if (x === 6 || y === 6) on = (x + y) % 2 === 0;
      else on = r() < .47;
      if (on) d += 'M' + x + ' ' + y + 'h1v1h-1z';
    }
    svg.setAttribute('viewBox', '0 0 21 21'); svg.setAttribute('shape-rendering', 'crispEdges');
    svg.innerHTML = '<path fill="#101828" d="' + d + '"/>';
  }

  /* ---------- Logos qui défilent SANS TROU : la moitié de piste couvre toujours la largeur visible ----------
     piste = [n jeux][n jeux] ; translateX(-50 %) retombe pile sur la seconde moitié. */
  function fillMarquee(track) {
    if (!track._set) track._set = track.innerHTML;
    var box = track.parentElement.clientWidth; if (!box) return;
    track.innerHTML = track._set;
    var setW = track.scrollWidth; if (!setW) return;
    var n = Math.max(1, Math.ceil((box + 2) / setW)), half = '';
    for (var i = 0; i < n; i++) half += track._set;
    track.innerHTML = half + half;
    track.style.animationDuration = (setW * n / (+track.getAttribute('data-speed') || 30)).toFixed(2) + 's';
    track._w = box;
  }
  function fillAll(root) {
    root.querySelectorAll('.pjb-mq').forEach(function (t) {
      var w = t.parentElement.clientWidth;
      if (w && (w !== t._w || t.scrollWidth / 2 < w + 1)) fillMarquee(t);
    });
  }

  /* ---------- Chemin des données : rail droit (nous) ou détour par le roaming (eux) ---------- */
  function layoutRoute(track) {
    var W = track.clientWidth, H = track.clientHeight; if (!W || !H) return;
    var dip = track.getAttribute('data-kind') === 'dip';
    /* stations + étiquettes centrées verticalement (bloc de y0 − 15 à y0 + 33, ou ym + 33 pour le détour) */
    var xa = 16, xb = W - 16, xm = W / 2, y0 = Math.max(18, Math.round(dip ? H / 2 - 30 : H / 2 - 9)), ym = dip ? Math.round(Math.min(H - 34, y0 + 42)) : y0;
    var d = dip
      ? 'M' + xa + ' ' + y0 + 'C' + (xa + (xm - xa) * .55) + ' ' + y0 + ' ' + (xm - (xm - xa) * .5) + ' ' + ym + ' ' + xm + ' ' + ym + 'S' + (xb - (xb - xm) * .55) + ' ' + y0 + ' ' + xb + ' ' + y0
      : 'M' + xa + ' ' + y0 + 'H' + xb;
    var svg = track.querySelector('.pjb-rt__svg'); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.querySelectorAll('path').forEach(function (p) { p.setAttribute('d', d); });
    track.querySelector('.pjb-rt__pkt').style.offsetPath = "path('" + d + "')";
    var pos = { a: [xa, y0], m: [xm, ym], b: [xb, y0] };
    ['a', 'm', 'b'].forEach(function (k) {
      track.querySelectorAll('.pjb-rt__stn--' + k + ', .pjb-rt__lbl--' + k).forEach(function (el) { el.style.setProperty('--sx', pos[k][0] + 'px'); el.style.setProperty('--sy', pos[k][1] + 'px'); });
    });
  }

  /* ---------- Vol vers Tokyo : arc, trajectoire de l'avion, épingles et bulle d'arrivée ----------
     Les épingles et la bulle peuvent déborder de la carte, jamais de la tuile ; elles ne se chevauchent pas
     (départ proche de Tokyo — Séoul, Shanghai — : l'épingle de départ passe SOUS son point). */
  function area(a, b) { return Math.max(0, Math.min(a.r, b.r) - Math.max(a.l, b.l)) * Math.max(0, Math.min(a.b, b.b) - Math.max(a.t, b.t)); }
  function layoutTrip(trip) {
    var W = trip.clientWidth; if (!W) return;
    var vb = trip.getAttribute('data-vb').split(' ').map(Number), k = W / vb[2];
    var LON0 = +trip.getAttribute('data-lon0'), LAT1 = +trip.getAttribute('data-lat1'), K = +trip.getAttribute('data-k');
    function P(ll) { var a = ll.split(',').map(Number); return [(a[0] - LON0) * K, LAT1 - a[1]]; }
    var f = P(trip.getAttribute('data-from')), t = P(trip.getAttribute('data-to'));
    var dist = Math.sqrt((t[0] - f[0]) * (t[0] - f[0]) + (t[1] - f[1]) * (t[1] - f[1]));
    var cx = (f[0] + t[0]) / 2, cy = Math.min(f[1], t[1]) - dist * .2;
    trip.querySelector('.pjb-trip__arc').setAttribute('d', 'M' + f[0] + ' ' + f[1] + 'Q' + cx + ' ' + cy + ' ' + t[0] + ' ' + t[1]);
    function px(p) { return [(p[0] - vb[0]) * k, (p[1] - vb[1]) * k]; }
    var F = px(f), T = px(t), C = px([cx, cy]);
    trip.querySelector('.pjb-trip__plane').style.offsetPath = "path('M" + F[0].toFixed(1) + ' ' + F[1].toFixed(1) + 'Q' + C[0].toFixed(1) + ' ' + C[1].toFixed(1) + ' ' + T[0].toFixed(1) + ' ' + T[1].toFixed(1) + "')";
    var rings = trip.querySelector('.pjb-trip__rings');
    rings.style.left = T[0] + 'px'; rings.style.top = T[1] + 'px';

    /* bornes utiles = la zone d'illustration de la tuile, exprimée dans le repère de la carte */
    var tb = trip.getBoundingClientRect(), ib = trip.parentElement.getBoundingClientRect();
    var B = { l: ib.left - tb.left + 4, t: ib.top - tb.top + 4, r: ib.right - tb.left - 4, b: ib.bottom - tb.top - 4 };
    function spot(pin, p, ax, below) {
      var w = pin.offsetWidth, h = pin.offsetHeight;
      var x = Math.min(Math.max(p[0] - w * ax, B.l), B.r - w), y = below ? p[1] + 10 : p[1] - 10 - h;
      return { l: x, t: y, r: x + w, b: y + h, below: below, stem: Math.min(Math.max(p[0] - x, 10), w - 10) };
    }
    function pose(pin, r) {
      pin.style.left = r.l + 'px'; pin.style.top = r.t + 'px'; pin.style.setProperty('--stem', r.stem + 'px');
      pin.classList.toggle('is-below', r.below);
    }
    function grow(r, m) { return { l: r.l - m, t: r.t - m, r: r.r + m, b: r.b + m }; }
    function out(r) { return Math.max(0, B.l - r.l) + Math.max(0, r.r - B.r) + Math.max(0, B.t - r.t) + Math.max(0, r.b - B.b); }
    var to = trip.querySelector('.pjb-trip__pin--to'), from = trip.querySelector('.pjb-trip__pin--from');
    var hello = trip.querySelector('.pjb-trip__hello'), hw = hello.offsetWidth, hh = hello.offsetHeight;
    var rTo = spot(to, T, .72, false), dotT = grow({ l: T[0], t: T[1], r: T[0], b: T[1] }, 12), dotF = grow({ l: F[0], t: F[1], r: F[0], b: F[1] }, 6);
    /* épingle de départ au-dessus (ou sous) son point × 7 places pour la bulle : la combinaison qui ne chevauche rien */
    var best = null;
    [false, true].forEach(function (below) {
      var rF = spot(from, F, .22, below);
      var base = area(grow(rF, 4), rTo) * 10 + out(rF) * 50 + (below ? 1 : 0);
      [[rTo.l - 8 - hw, T[1] - 64], [T[0] - hw / 2, T[1] + 18], [rTo.l - 8 - hw, T[1] + 14], [B.r - hw, T[1] + 18],
       [B.l, B.t], [B.l, B.b - hh], [B.r - hw, B.b - hh], [B.r - hw, B.t]].forEach(function (c, i) {
        var x = Math.min(Math.max(c[0], B.l), B.r - hw), y = Math.min(Math.max(c[1], B.t), B.b - hh);
        var r = { l: x, t: y, r: x + hw, b: y + hh }, g = grow(r, 6);
        var s = base + area(g, rTo) + area(g, rF) + area(r, dotT) + area(r, dotF) + i * .01;
        if (!best || s < best.s) best = { s: s, rF: rF, r: r };
      });
    });
    pose(to, rTo); pose(from, best.rF);
    hello.style.left = best.r.l + 'px'; hello.style.top = best.r.t + 'px';
  }

  function init(sec) {
    if (sec._pjb) return; sec._pjb = true;
    var GB = sec.getAttribute('data-gb') || 'GB', DEC = sec.getAttribute('data-dec') || '.';
    sec.querySelectorAll('svg.pjb-qr').forEach(drawQr);

    function layout() {
      sec.querySelectorAll('.pjb-rt__track').forEach(layoutRoute);
      sec.querySelectorAll('.pjb-trip').forEach(layoutTrip);
      fillAll(sec);
    }
    layout();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (es) {
        es.forEach(function (e) {
          var el = e.target;
          if (el.classList.contains('pjb-rt__track')) layoutRoute(el);
          else if (el.classList.contains('pjb-land')) el.querySelectorAll('.pjb-trip').forEach(layoutTrip);
          else fillAll(el);
        });
      });
      sec.querySelectorAll('.pjb-rt__track, .pjb-land, .pjb-apps').forEach(function (el) { ro.observe(el); });
    }

    /* compteur de Go : monte lentement jusqu'à 20 (~36 s), marque une pause, repart de zéro */
    var runs = [].slice.call(sec.querySelectorAll('.pjb-gb')), gb = 0, hold = 0;
    function fmt(v) { return v.toFixed(1).replace('.', DEC) + ' ' + GB; }
    if (MOTION && runs.length) {
      runs.forEach(function (r) { r.textContent = fmt(0); });
      setInterval(function () {
        var live = runs.filter(function (r) { return r.closest('.is-live'); });
        if (!live.length) return;
        if (gb >= 20) { if (++hold < 30) return; hold = 0; gb = 0; } else gb = Math.min(20, gb + .045);
        live.forEach(function (r) { r.textContent = fmt(gb); });
      }, 80);
    }

    /* tuiles visibles : .is-live ; hors écran, l'avion en papier (SMIL) s'arrête aussi */
    var svgs = sec.querySelectorAll('svg.pjb-fly');
    if (!MOTION) svgs.forEach(function (s) { if (s.pauseAnimations) { s.pauseAnimations(); if (s.setCurrentTime) s.setCurrentTime(3.2); } });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); }); }, { rootMargin: '60px 0px' });
      sec.querySelectorAll('.pjb-t').forEach(function (t) { io.observe(t); });
      if (MOTION) new IntersectionObserver(function (es) {
        es.forEach(function (e) { svgs.forEach(function (s) { if (!s.pauseAnimations) return; if (e.isIntersecting) s.unpauseAnimations(); else s.pauseAnimations(); }); });
      }, { rootMargin: '150px 0px' }).observe(sec);
    } else {
      sec.querySelectorAll('.pjb-t').forEach(function (t) { t.classList.add('is-live'); });
    }
  }

  function boot() { document.querySelectorAll('.pj-bento').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* éditeur de thème : la section rechargée arrive sans le script */
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.pj-bento').forEach(init); });
})();
